// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';

import {
  assetResolver,
} from '../../utils';

import {
  ButtonContainer,
  ButtonText,
  ButtonIcon,
} from './styles';

const ExploreNavigationButton = ({ open, onClick, alternate }) => (
  <ButtonContainer aria-haspopup="menu" alternate={alternate} aria-expanded={open} open={open} aria-controls="nav-explore" onClick={onClick}>
    <ButtonText>Explore</ButtonText>
    <ButtonIcon src={assetResolver(alternate ? 'down-arrow-dark.svg' : 'down-arrow.svg')} alt="Menu" />
  </ButtonContainer>
);

ExploreNavigationButton.propTypes = {
  open: PropType.bool,
  alternate: PropType.bool,
  onClick: PropType.func,
};

ExploreNavigationButton.defaultProps = {
  open: false,
  alternate: false,
  onClick: () => undefined,
};

export default ExploreNavigationButton;
